<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->
<app-template></app-template>
<div id="viewContent" [ngClass]="{'menuCollapsed' : this.menuCollapsed}">
    <router-outlet></router-outlet>
</div>
